/**
 * FIX-004 (VIDEO STUDIO branding): the one canonical brand lockup —
 * the `VS` rounded badge + `VIDEO STUDIO` wordmark — used everywhere the
 * product identifies itself (the authenticated app header, the sign-in
 * screen) so the identity never drifts between two hand-typed copies.
 * `size` only scales typography/spacing for the header's own narrow-
 * viewport responsiveness — it never changes the brand's own shape/
 * colors, which come entirely from the shared `--accent`/`--accent-contrast`
 * theme tokens.
 */
export function BrandLockup({ size = "md" }: { readonly size?: "sm" | "md" }) {
  return (
    <span className={`brand-lockup brand-lockup-${size}`}>
      <span className="brand-badge" aria-hidden="true">
        VS
      </span>
      <span className="brand-wordmark">VIDEO STUDIO</span>
    </span>
  );
}
